import BaseApi from '../base/base'
import UserQuestion from '../../models/user_question'
import LessonRelative from '../../models/lesson_relative'
import CourseRelative from '../../models/course_relative'
import UserQuestionForm, { UserQuestionListForm } from '../../forms/user_question'

export default class UserQuestionApi extends BaseApi {
  constructor() {
    super()
    this.path = '/questions'
  }

  async index(params: UserQuestionListForm) {
    this.path = '/questions'
    const response = await this.getRequest(params)
    return [
      response.meta.pagination,
      response.data.map((element) => {
        return new UserQuestion(element)
      })
    ]
  }

  async my(params = { page: 1, search: '' }) {
    this.path = '/questions/my'
    const response = await this.getRequest(params)
    return [
      response.meta.pagination,
      response.data.map((element) => {
        return new UserQuestion(element)
      })
    ]
  }

  async myQuestionAnswer(params = { page: 1, search: '' }) {
    this.path = '/questions/my_question_answers'
    const response = await this.getRequest(params)
    return [
      response.meta.pagination,
      response.data.map((element) => {
        return new UserQuestion(element)
      })
    ]
  }

  async create(userQuestionForm: UserQuestionForm) {
    this.path = '/questions'
    const response = await this.postFormData(userQuestionForm.toFormData())
    return new UserQuestion(response.data)
  }

  async update(questionId: number, userQuestionForm: UserQuestionForm) {
    this.path = `/questions/${questionId}`
    const response = await this.putFormData(userQuestionForm.toFormData())
    return response
  }

  async show(id = '0') {
    this.path = `/questions/${id}`
    const response = await this.getRequest()
    return new UserQuestion(response.data)
  }

  async delete(id = '0') {
    this.path = `/questions/${id}`
    await this.deleteRequest()
    return
  }

  async relativeLists(id = '0') {
    this.path = `/questions/${id}/relative_lists`
    const response = await this.getRequest()

    return {
      sameLessonQuestions: response.data.sameLessonQuestions.map((element) => {
        return new UserQuestion(element)
      }),
      sameCourseLessons: response.data.sameCourseLessons.map((element) => {
        return new LessonRelative(element)
      }),
      courses: response.data.courses.map((element) => {
        return new CourseRelative(element)
      })
    }
  }
}
